module.exports = __webpack_public_path__ + "img/telegram-logo.53d06b92.svg";